module.exports = __webpack_public_path__ + "static/media/search-job-home-page.cee6cd95.svg";